import { combineReducers } from 'redux';

import gradebook from './gradebook';
import user from './user';

const rootReducer = combineReducers({
  gradebook,
  user,
});

export default rootReducer;
